// FIXME: not the external configuration, another one
import Keycloak from 'keycloak-js';

import { configuration } from '@/config';

export const keycloak = new Keycloak({
  url: configuration.keycloakUrl,
  realm: configuration.keycloakRealm,
  clientId: configuration.keycloakClientId,
});
